<div
  class="h100"
  style="padding-top: 30px; padding-bottom: 30px"
  fxLayout="column"
  fxLayoutGap="30px"
>
  <div class="address-box" fxLayout="column">
    <span class="address-box-title">{{ "ADDRESS" | translate }}</span>
    <span>{{ (userService.user | async).additionalAddress }}</span>
    <span>{{ (userService.user | async).no }}</span>
    <span>{{ (userService.user | async).postCode }}</span>
    <span>{{ (userService.user | async).city }}</span>
    <span>{{ (userService.user | async).state }}</span>
    <span>{{ (userService.user | async).country }}</span>
  </div>

  <div fxFlex></div>

  <button fxFLexAlign="center" mat-button routerLink="../address">
    {{ "USE_DIFFERENT_ADDRESS" | translate }}
  </button>

  <button
    fxFlexAlign="center"
    mat-flat-button
    color="primary"
    class="my-button"
    (click)="onContinue()"
  >
    {{ "CONTINUE" | translate }}
  </button>
</div>
